import { Bug, ChevronDown, ChevronUp } from 'lucide-react';
import { useSessionDebug } from '@/hooks/useSessionDebug';
import { useAuth } from '../auth-context';

function statusLabel(status: 'ACTIVE' | 'WARNING' | 'CRITICAL' | 'EXPIRED'): string {
  if (status === 'ACTIVE') return 'ACTIVE';
  if (status === 'WARNING') return 'WARNING';
  if (status === 'CRITICAL') return 'CRITICAL';
  return 'EXPIRED';
}

export function SessionDebugPanel() {
  const { isAuthenticated } = useAuth();
  const debugVisibleByFlag = import.meta.env.VITE_SHOW_SESSION_DEBUG === 'true';
  const enabled = import.meta.env.DEV && debugVisibleByFlag && isAuthenticated;
  const { state, isOpen, setIsOpen, colors } = useSessionDebug(enabled);

  if (!enabled) return null;

  return (
    <div className="fixed bottom-4 right-4 z-[1000] w-[360px] max-w-[92vw]">
      <div className="rounded-lg border border-slate-300 bg-white shadow-2xl">
        <button
          type="button"
          className="flex w-full items-center justify-between px-3 py-2 text-left text-sm font-bold text-slate-800"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span className="flex items-center gap-2">
            <Bug className="h-4 w-4 text-slate-600" />
            SESSION DEBUG
          </span>
          {isOpen ? <ChevronDown className="h-4 w-4" /> : <ChevronUp className="h-4 w-4" />}
        </button>

        {isOpen ? (
          <div className="space-y-2 border-t border-slate-200 p-3 text-xs text-slate-700">
            <div className="grid grid-cols-2 gap-2">
              <div>Config Timeout:</div>
              <div className="font-semibold">
                {state.timeoutMinutes} min ({state.timeoutSeconds}s)
              </div>
              <div>Time Remaining:</div>
              <div className="font-semibold">{state.secondsUntilExpiry}s</div>
              <div>Status:</div>
              <div className={`inline-flex items-center rounded border px-2 py-0.5 font-bold ${colors}`}>
                {statusLabel(state.status)}
              </div>
            </div>

            <div className="border-t border-slate-200 pt-2">
              <div>Last Activity (frontend): {state.secondsSinceFrontendEvent}s ago</div>
              <div>Source: {state.lastSource}</div>
            </div>

            <div className="border-t border-slate-200 pt-2">
              <div>Requests passive: {state.passiveRequestsCount}</div>
              <div>Requests active: {state.activeRequestsCount}</div>
            </div>

            <div className="border-t border-slate-200 pt-2 text-[11px] leading-4 text-slate-600">
              <div>Backend lastActivity: {state.backendLastActivity}</div>
              <div>Frontend lastEvent: {state.frontendLastEvent}</div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  );
}
